module.exports = __webpack_public_path__ + "static/media/youtube.e0f72b9f.png";